import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from "../../services/translation";
import * as PropType from "prop-types";

export default class PlannerListLayout extends Component {

    static propTypes = {
        switchLayout: PropTypes.func,
        switchMap: PropTypes.func,
        currentLayout: PropTypes.string,
        mapLayout: PropTypes.bool,
        showMap: PropTypes.bool,
        enableMap: PropTypes.bool,
        layout: PropType.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.innerWidth <= 768
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ isMobile: window.innerWidth <= 768 });
    }

    render() {
        const {switchLayout, currentLayout, mapLayout, switchMap, showMap, enableMap, layout} = this.props;
        const { isMobile } = this.state;

        return (
            <div className={"plannerLayoutVariants" + ( mapLayout ? ' mapLayout' : '')}>
                {!layout &&
                    <div className="plannerLayoutBtn layoutVariantList">
                        <button onClick={() => switchLayout('list')}
                                className={(currentLayout === 'list' ? ' active' : '')}>
                            {isMobile ? mapLayout ? '' : translate('planner_list.layout.list') : translate('planner_list.layout.list')}
                        </button>
                    </div>
                }

                {!layout &&
                    <div className="plannerLayoutBtn layoutVariantTeaser">
                        <button onClick={() => switchLayout('compare')}
                                className={(currentLayout === 'compare' ? ' active' : '')}>
                            {isMobile ? mapLayout ? '' : translate('planner_list.layout.compare') : translate('planner_list.layout.compare')}
                        </button>
                    </div>
                }

                {mapLayout &&
                    <div className={"plannerLayoutBtn layoutVariantMap" + (showMap ? ' active' : '')}>
                        <button onClick={() => switchMap()} disabled={!enableMap}
                                className={enableMap ? 'enabled' : 'disabled'}>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1 6.60999V22.61L8 18.61L16 22.61L23 18.61V2.60999L16 6.60999L8 2.60999L1 6.60999Z"
                                    stroke={enableMap ? "#000" : "#BABABA"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M8 2.60999V18.61" stroke={enableMap ? "#000" : "#BABABA"} strokeWidth="2" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                                <path d="M16 6.60999V22.61" stroke={enableMap ? "#000" : "#BABABA"} strokeWidth="2" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/PlannerListLayout.js